import React from 'react';

interface FormattedDateProps {
  dateString: string;
  locale?: string;
  options?: Intl.DateTimeFormatOptions;
}

const FormattedDate: React.FC<FormattedDateProps> = ({
  dateString,
  locale = 'en-US',
  options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  },
}) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) return <span>Invalid date</span>;

  return <span>{date.toLocaleString(locale, options)}</span>;
};

export default FormattedDate;
